import { IconButton } from '@material-ui/core';
import * as lib from '~/dependencies';
import { colors, paddings, fonts, margins } from '~/layout';

export const Container = lib.styled.div`
  display: flex;
  background-color: ${colors.white};
  flex-direction: column;
  position: relative;
  padding: ${paddings.alternative}px;
  padding-bottom: ${paddings.default}px;
`;

export const Wrapper = lib.styled.div`
  position: absolute !important;
  width: 100%;
  top: 0px;
  bottom: 0px;
  overflow-y: auto;
  overflow-x: hidden;
  background-color: ${colors.white};
  &::-webkit-scrollbar { width: 0 !important }
  overflow: -moz-scrollbars-none !important; }
  -ms-overflow-style: none !important; }
  z-index: 900;
`;

export const AddContactButton = lib.styled.div`
  display: flex;
  cursor: pointer;
  justify-content: center;
  align-items: center;
  margin-right: 7px;
  a { font-size: 0!important }
`;

export const BackButton = lib.styled.a`
  color: ${colors.black};
  opacity: 0.5;
  font-size: ${fonts.default}px;
  font-weight: 600;
  margin-right: ${margins.links}px;
  cursor: pointer;

  &:hover {
    color: ${colors.lightBlue};
  }
`;

export const BoxDirection = lib.styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  padding: ${paddings.reset}px;
  padding-top: 15px;

  .MuiSvgIcon-root {
    cursor: pointer;
  }
`;

export const DirectionLabel = lib.styled.div`
  font-size: 16px;
  margin-left: 10px;
  font-weight: 900;
  cursor: pointer;
`;

export const Close = lib.styled.div`
  width: 20%;
  float: right;
  font-weight: bold;
  text-align: right;
  cursor: pointer;
`;

export const Content = lib.styled.div`
  display: flex;
  width: 80%;
  flex-direction: row;
`;

export const DateExtended = lib.styled.span`
  font-size: ${fonts.default}px;
  color: ${colors.black};
  opacity: 0.5;
`;

export const Space = lib.styled.div`
  display: flex;
  height: ${props => props.height}px;
  min-height: ${props => props.height}px;
  width: 100%;
`;

export const BoxInformations = lib.styled.div`
  border: 1px dotted ${colors.lightGray06};
  border-radius: 10px;
  background-color: ${colors.white02};
`;

export const Row = lib.styled.div`
  display: flex;
  flex: 1;
  flex-direction: row;
  min-height: 49px;
  height: 49px;
  align-items: center;
  justify-content: space-between;
  padding: 0px 10px 0px 10px;
  border-bottom: 1px dotted ${colors.lightGray06};

  &:first-child {
    border-top-right-radius: 1pt solid ${colors.lightGray03};
    border-top-left-radius: 1pt solid ${colors.lightGray03};
  }

  &:last-child {
    border-bottom-right-radius: 1pt solid ${colors.lightGray03};
    border-bottom-left-radius: 1pt solid ${colors.lightGray03};
    border-bottom: 0px!important;
  }

  .holderDiv {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin-top: 3px;

    .MuiCircularProgress-root {
      width: 34px!important;
      height: 34px!important;

    }
    .MuiCircularProgress-colorPrimary {
      color: ${colors.lightBlue};
    }
  }

  .icon-2 {
    margin-top: -34px;
    padding: 0!important;
  }

`;

export const BoxData = lib.styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  height: 49px;

  button {
    padding: 0px!important;
  }

  &:first-child {
    min-width: 70px;
  }

  &:nth-child(2) {
    flex: 1!important;
  }

  &:last-child {
    div {
      width: 26px;
      height: 26px;
    }
  }

  .icon-add {
    font-size: 31px;
    color: ${colors.green05}
  }

  .icon-edit {
    max-width: 26px;
    max-height: 27px;
    font-size: 18px;
    color: white;
    background-color: ${colors.green05};
    border-radius: 18px;
    padding: 5px;
    margin-right: 2px;
  }

  .icon {
    margin-top: -1px;
  }

  .icon-sms {
    width: 26px;
    height: 27px;
    background-color: ${colors.green05}
    border-radius: 50px;
    margin-right: 10px;
    &:hover {
      background-color: ${colors.green05}
    }
  }

  .icon-sms-svg {
    width: 18px;
    height: 16px;
    color: ${colors.white}
  }

  span {
    font-size: ${fonts.default}px;
    color: ${colors.lightOrange};
    opacity: 0.9;
    font-weight: bold;
    cursor: pointer;
  }

  .queue-name {
    display: -webkit-box; 
    font-size: ${fonts.default}px;
    color: ${colors.black};
    opacity: 0.6;
    font-weight: 500;
    cursor: auto;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .contact-name {
    font-size: ${fonts.default}px;
    color: ${colors.black};
  }

  .contact-number {
    font-size: ${fonts.default}px;
    color: ${colors.black};
    opacity: 0.6;
    font-weight: 500;
    max-width: 100px;
  }

  .TextSecundary {
    font-size: ${fonts.default}px;
    color: ${colors.black};
    opacity: 0.5;
  }

  .actions-container {
    display: flex !important;
    flex-direction: row !important;
    justify-content: space-around !important;
    align-items: center !important;
  }
`;

export const Label = lib.styled.div`
  font-size: ${fonts.default}px;
  color: ${colors.black};
  opacity: 0.5;
`;

export const IconButtonComponent = lib.styled(IconButton)`
  cursor: pointer;
`;

export const DottedDivisor = lib.styled.div`
  display: flex;
  height: 1px;
  width: 370px;
  margin: 0 auto;
  border-bottom: 1px dotted ${colors.lightGray06};
`;

export const RecentContainer = lib.styled.div`
  padding-left: 15px;
  padding-right: 15px;
  margin-bottom: 50px;
`;

export const AddTagsNotesButton = lib.styled.button`
  height: 50px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  border-color: transparent;
  cursor: pointer;
  ${props =>
    props.action === 'add-tags'
      ? 'width: 184px; border-bottom-left-radius: 10px; margin-left: -12px;'
      : 'width: 185px; border-bottom-right-radius: 10px; margin-right: -12px;'}

  .icon {
    margin-right: 8px;
  }
`;
